import { Alert } from 'rsuite';
import { queryClient } from '../../../../../../App';
import { listRules, ListRulesBody } from './service';

export const listRulesQuery = (model?: ListRulesBody) => ({
  queryKey: ['ipa.strategy.rules', model],
  queryFn: () => listRules(model),
});

export const listRulesQueryDeleteMutation = () => ({
  onSuccess: () => {
    const [queryKey] = listRulesQuery().queryKey;
    queryClient.invalidateQueries([queryKey]);
    Alert.success('Regra excluída com sucesso');
  },
  onError: () => {
    Alert.error('Erro ao excluir regra');
  },
});
